import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CreateTwoToneIcon from '@mui/icons-material/CreateTwoTone';

function DataTable() {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    console.log(search);
    const navigate = useNavigate();

    const handleApicall = async () => {
        try {
            const response = await axios.get('https://generativebackend.onrender.com/api/employeeData');
            setData(response.data.employeeData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        handleApicall();
    }, []);

    // useEffect(() => {
    //     const currid = localStorage.getItem('detail');
    //     if (currid && data.length) {
    //         const matchData = data.filter((item) => item.email == currid);
    //         if (matchData) {
    //             setData(matchData);
    //         }
    //     }
    // }, [data]);

    const handleRemove = async (_id) => {
        try {
            await axios.delete(`https://generativebackend.onrender.com/api/employeeData/${_id}`);
            const updatedData = data.filter((item) => item._id !== _id);
            setData(updatedData);
            handleApicall();
        } catch (error) {
            console.error('Error removing data:', error);
        }
    };

    const handleUpdate = (_id) => {
        navigate(`detail/${_id}`);
    };
    const handleSearch = async (event) => {
        setSearch(event.target.value);
        try {
            const searchResponse = await axios.get(`https://generativebackend.onrender.com/api/search?searchQuery=${search}`);
            console.log(data);
            setData(searchResponse?.data);
        } catch (error) {}
    };

    const handleSearchRemove = () => {
        setSearch('');
        handleApicall();
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ textAlign: 'right' }}>
                    Total <Chip label={data?.length} color="primary" variant="outlined" />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="Search"
                        value={search}
                        onChange={handleSearch}
                        style={{ flex: 1, marginRight: '8px' }} // Adjust spacing as needed
                    />
                    <Button onClick={handleSearchRemove} variant="contained" color="secondary">
                        X
                    </Button>
                </div>
            </div>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>First Name</TableCell>
                            <TableCell align="right">Last Name</TableCell>
                            <TableCell align="right">Email</TableCell>
                            <TableCell align="right">Contact No</TableCell>
                            <TableCell align="right">Country</TableCell>
                            <TableCell align="right">State</TableCell>
                            <TableCell align="right">City</TableCell>
                            <TableCell align="right">Address Line1</TableCell>
                            <TableCell align="right">Address Line2</TableCell>
                            <TableCell align="right">Update</TableCell>
                            <TableCell align="right">Remove</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="right">{row.firstName}</TableCell>
                                <TableCell align="right">{row.lastName}</TableCell>
                                <TableCell align="right">{row.email}</TableCell>
                                <TableCell align="right">{row.contactNo}</TableCell>
                                <TableCell align="right">{row.country}</TableCell>
                                <TableCell align="right">{row.state}</TableCell>
                                <TableCell align="right">{row.city}</TableCell>
                                <TableCell align="right">{row.addressLine1}</TableCell>
                                <TableCell align="right">{row.addressLine2}</TableCell>
                                <TableCell align="right">
                                    {' '}
                                    <Button onClick={() => handleUpdate(row._id)}>
                                        {' '}
                                        <CreateTwoToneIcon />
                                    </Button>{' '}
                                </TableCell>
                                <TableCell align="right">
                                    {' '}
                                    <Button onClick={() => handleRemove(row._id)}>
                                        {' '}
                                        <DeleteIcon sx={{ color: 'red' }} />
                                    </Button>{' '}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {data && data.length <= 0 && <p style={{ textAlign: 'center' }}>No data found</p>}
        </>
    );
}

export default DataTable;
